/**
 * Global Discount Handler
 * Handles dynamic product price recalculation and strikethrough compare-at price display.
 * Applies strictly to standard product pages; completely excludes ring builder flow.
 */
(function () {
  'use strict';

  function isExcludedPage() {
    var search = (window.location.search || '').toLowerCase();
    var href = (window.location.href || '').toLowerCase();
    var path = (window.location.pathname || '').toLowerCase();

    return (
      search.indexOf('diamond_select') > -1 ||
      href.indexOf('diamond_select') > -1 ||
      path.indexOf('diamond_select') > -1 ||
      path.indexOf('build-your-own-ring') > -1 ||
      path.indexOf('ringbuilder') > -1 ||
      href.indexOf('ringbuilder') > -1
    );
  }

  if (isExcludedPage()) {
    return;
  }

  function getConfig() {
    return window.globalDiscountConfig || {
      enabled: false,
      percentage: 0,
      type: 'percentage',
      fixedAmount: 0
    };
  }

  function calculateDiscount(price, config) {
    if (!config || !config.enabled) return price;
    var originalPrice = Number(price) || 0;
    if (originalPrice <= 0) return originalPrice;

    if (config.type === 'percentage' && config.percentage > 0) {
      var factor = (100 - Number(config.percentage)) / 100;
      return Math.round(originalPrice * factor);
    } else if (config.type === 'fixed' && config.fixedAmount > 0) {
      return Math.max(0, originalPrice - Number(config.fixedAmount));
    }
    return originalPrice;
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || (window.globalDiscountConfig && window.globalDiscountConfig.moneyFormat) || '${{amount}}';
    if (typeof themeCurrency !== 'undefined' && themeCurrency.formatMoney) {
      return themeCurrency.formatMoney(cents, format);
    }
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }
    var value = (cents / 100).toFixed(2);
    return '$' + value;
  }

  function applyDiscountToPriceWrapper(wrapper, variant) {
    if (!wrapper || !variant) return;
    var config = getConfig();
    if (!config.enabled) return;

    var productPriceElem = wrapper.querySelector('[data-product-price]');
    var comparePriceElem = wrapper.querySelector('[data-compare-price]');
    var compareTextElem = wrapper.querySelector('[data-compare-text]');

    var originalPrice = Number(variant.price);
    var discountedPrice = calculateDiscount(originalPrice, config);
    var comparePrice = (variant.compare_at_price && Number(variant.compare_at_price) > originalPrice)
      ? Number(variant.compare_at_price)
      : originalPrice;

    if (discountedPrice < originalPrice) {
      if (productPriceElem) {
        var formattedDiscount = formatMoney(discountedPrice);
        if (productPriceElem.getAttribute('data-discount-applied') !== String(discountedPrice) || productPriceElem.innerHTML !== formattedDiscount) {
          productPriceElem.setAttribute('data-discount-applied', String(discountedPrice));
          productPriceElem.innerHTML = formattedDiscount;
          productPriceElem.classList.add('product__price--sale');
        }
      }

      if (comparePriceElem) {
        var formattedCompare = formatMoney(comparePrice);
        if (comparePriceElem.innerHTML !== formattedCompare || comparePriceElem.classList.contains('hide')) {
          comparePriceElem.innerHTML = formattedCompare;
          comparePriceElem.classList.remove('hide');
          comparePriceElem.style.removeProperty('display');
        }
      }

      if (compareTextElem) {
        compareTextElem.classList.remove('hide');
        compareTextElem.style.removeProperty('display');
      }
    }
  }

  function getProductDataFromForm(form) {
    if (!form) return null;
    var container = form.closest('#template-product') || form.closest('.product__wrapper') || form.closest('.grid') || document;
    var jsonElem = container.querySelector('[data-product-json]');
    if (jsonElem) {
      try {
        return JSON.parse(jsonElem.innerHTML);
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function getSelectedVariant(form, product) {
    if (!product || !product.variants || product.variants.length === 0) return null;

    // 1. Try matching by current selected option inputs in the form
    var optionInputs = form.querySelectorAll('[data-single-option-selector], input[name^="options"]:checked, select[name^="options"], .variant-input:checked, .swatch input[type="radio"]:checked');
    if (optionInputs.length > 0) {
      var optionMap = {};
      optionInputs.forEach(function (input) {
        var index = input.getAttribute('data-index');
        var val = input.value;
        if (index && val) {
          optionMap[index.toLowerCase()] = val;
        }
      });

      if (Object.keys(optionMap).length > 0) {
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var match = true;
          if (v.options && Array.isArray(v.options)) {
            for (var o = 0; o < v.options.length; o++) {
              var key = 'option' + (o + 1);
              if (optionMap[key] && optionMap[key] !== v.options[o]) {
                match = false;
                break;
              }
            }
          }
          if (match) {
            return v;
          }
        }
      }
    }

    // 2. Try select[name="id"] / input[name="id"] / [data-product-select]
    var idInput = form.querySelector('[name="id"], [data-product-select]');
    if (idInput && idInput.value) {
      var selectedId = Number(idInput.value);
      for (var j = 0; j < product.variants.length; j++) {
        if (product.variants[j].id === selectedId) {
          return product.variants[j];
        }
      }
    }

    // 3. Try URL variant parameter
    var search = window.location.search || '';
    if (search.indexOf('variant=') > -1) {
      var match = search.match(/variant=(\d+)/);
      if (match && match[1]) {
        var urlVariantId = Number(match[1]);
        for (var k = 0; k < product.variants.length; k++) {
          if (product.variants[k].id === urlVariantId) {
            return product.variants[k];
          }
        }
      }
    }

    return product.variants[0];
  }

  function handlePriceUpdate() {
    if (isExcludedPage()) return;
    var config = getConfig();
    if (!config.enabled) return;

    var forms = document.querySelectorAll('form[action*="/cart/add"], form.product-form, .product__form form');
    if (forms.length === 0) {
      forms = [document.body];
    }

    forms.forEach(function (form) {
      var product = getProductDataFromForm(form);
      if (product) {
        var variant = getSelectedVariant(form, product);
        if (variant) {
          var container = form.closest('#template-product') || form.closest('.product__wrapper') || document;
          var wrappers = container.querySelectorAll('[data-price-wrapper]');
          wrappers.forEach(function (wrap) {
            applyDiscountToPriceWrapper(wrap, variant);
          });
        }
      }
    });
  }

  function init() {
    if (isExcludedPage()) return;
    handlePriceUpdate();

    // Listen to form input and option changes on product page
    document.addEventListener('change', function (evt) {
      if (evt.target.matches('[data-single-option-selector], [data-product-select], .product-form select, .product-form input, .swatch input, .variant-input, [name="id"], [name^="options"]')) {
        setTimeout(handlePriceUpdate, 10);
        setTimeout(handlePriceUpdate, 50);
        setTimeout(handlePriceUpdate, 150);
        setTimeout(handlePriceUpdate, 300);
      }
    });

    document.addEventListener('click', function (evt) {
      if (evt.target.closest('.swatch-element, .variant-field, .variant__button-label, [data-single-option-selector]')) {
        setTimeout(handlePriceUpdate, 10);
        setTimeout(handlePriceUpdate, 50);
        setTimeout(handlePriceUpdate, 150);
        setTimeout(handlePriceUpdate, 300);
      }
    });

    document.addEventListener('shopify:section:load', function () {
      setTimeout(handlePriceUpdate, 50);
    });

    // Observer for price elements on product page to detect and override theme.js price resets
    var priceWrappers = document.querySelectorAll('[data-price-wrapper]');
    if (priceWrappers.length > 0 && window.MutationObserver) {
      var isUpdating = false;
      var observer = new MutationObserver(function () {
        if (isUpdating) return;
        isUpdating = true;
        handlePriceUpdate();
        setTimeout(function () {
          isUpdating = false;
        }, 60);
      });

      priceWrappers.forEach(function (wrapper) {
        observer.observe(wrapper, { childList: true, characterData: true, subtree: true });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
